// ── markBurst ─────────────────────────────────────────────────────────────────
// "Is someone in the middle of marking a run right now?" Cinematics that interrupt
// (the achievement medallion, 2026-10-28: a new member hammering Watched on Animal
// Control got the 📺 overlay mid-burst and rage-tapped it away) should wait for the
// marks to pause, the way they already wait for the toast rail. One listener on the
// app-wide nextep:progress-marked event keeps the last few mark times; pure helpers
// decide. Tested in markBurst.test.js.
export const BURST_GAP_MS = 1500     // two marks closer than this = a burst
export const BURST_HOLD_MS = 1800    // hold this long after the last mark of a burst

export function noteMark(marks, now = Date.now()) {
  return [...(marks || []).filter(t => now - t <= BURST_GAP_MS * 4), now].slice(-6)
}

// True while a burst is live: the last two marks were close together and the last
// one is recent. A single mark never counts: one Watched, one medallion, as before.
export function burstActive(marks, now = Date.now()) {
  if (!marks || marks.length < 2) return false
  const a = marks[marks.length - 1], b = marks[marks.length - 2]
  return a - b <= BURST_GAP_MS && now - a <= BURST_HOLD_MS
}

let marks = []
let installed = false
export function installMarkBurst() {
  if (installed || typeof window === 'undefined') return
  installed = true
  window.addEventListener('nextep:progress-marked', () => { marks = noteMark(marks) })
}
export const markBurstActive = (now = Date.now()) => burstActive(marks, now)
